import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  IconButton,
} from '@mui/material';
import { motion } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { useNavigate } from 'react-router-dom';

const AgentTypeSelection = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 20
      }
    }
  };

  const handleSelectType = (type) => {
    if (type === 'inbound') {
      navigate('/agents/new/inbound');
    } else {
      navigate('/agents/new/outbound');
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Paper
        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        elevation={0}
        sx={{ p: 3 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
          <IconButton
            onClick={() => navigate('/agents')}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4">
            Select Agent Type
          </Typography>
        </Box>

        <Grid container spacing={4} sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <motion.div variants={itemVariants}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  cursor: 'pointer',
                  border: '2px solid',
                  borderColor: 'primary.main',
                  borderRadius: 2,
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleSelectType('inbound')}
              >
                <Box sx={{ textAlign: 'center' }}>
                  <CallReceivedIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h5" gutterBottom>
                    Inbound Agent
                  </Typography>
                  <Typography color="text.secondary" sx={{ mb: 3 }}>
                    Create an agent that receives calls through a SIP connection.
                    Configure LiveKit settings, prompts, and voice options.
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<CallReceivedIcon />}
                    onClick={() => handleSelectType('inbound')}
                  >
                    Create Inbound Agent
                  </Button>
                </Box>
              </Paper>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6}>
            <motion.div variants={itemVariants}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  cursor: 'pointer',
                  border: '2px solid',
                  borderColor: 'primary.main',
                  borderRadius: 2,
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleSelectType('outbound')}
              >
                <Box sx={{ textAlign: 'center' }}>
                  <CallMadeIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h5" gutterBottom>
                    Outbound Agent
                  </Typography>
                  <Typography color="text.secondary" sx={{ mb: 3 }}>
                    Create an agent that makes outbound calls using predefined LiveKit credentials.
                    Quick setup with just a name.
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<CallMadeIcon />}
                    onClick={() => handleSelectType('outbound')}
                  >
                    Create Outbound Agent
                  </Button>
                </Box>
              </Paper>
            </motion.div>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default AgentTypeSelection; 